import { SearchInput, type SearchInputProps } from "@design-system/shadcn";
import { cn } from "@design-system/utils";
import React from "react";

interface DataTableFiltersSearchProps extends Omit<
  SearchInputProps,
  "debounceMs"
> {
  debounceMs?: number;
}

function FiltersSearch({
  className,
  debounceMs = 300,
  ...props
}: DataTableFiltersSearchProps) {
  return (
    <SearchInput
      {...props}
      debounceMs={debounceMs}
      className={cn("max-w-70", className)}
    />
  );
}

export { FiltersSearch };
export type { DataTableFiltersSearchProps };
